import { datadogLogs } from '@datadog/browser-logs';
import { getOnboardingToken } from './superFetch';

const SESSION_EXPIRED_STORAGE_KEY = 'sessionExpiredContext';

const safeGetPathname = () => {
  if (typeof window === 'undefined' || !window.location) return undefined;
  return window.location.pathname;
};

const safeHasToken = () => {
  return Boolean(getOnboardingToken());
};

export const buildSessionExpiredContext = (details = {}) => {
  return {
    eventType: 'session_expired',
    reason: details.reason || 'unknown',
    source: details.source || 'unknown',
    component: details.component || details.source || 'unknown',
    fromPath: details.fromPath || safeGetPathname(),
    status: details.status,
    endpoint: details.endpoint,
    message: details.message,
    item: details.item,
    itemName: details.itemName,
    tokenPresent: safeHasToken(),
  };
};

export const setSessionExpiredContext = (details = {}) => {
  const context = buildSessionExpiredContext(details);
  try {
    sessionStorage.setItem(
      SESSION_EXPIRED_STORAGE_KEY,
      JSON.stringify(context)
    );
  } catch (error) {
    // Ignore storage errors
  }
  return context;
};

export const getSessionExpiredContext = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_EXPIRED_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const navigateToSessionExpired = (navigate, details = {}) => {
  const context = setSessionExpiredContext(details);
  navigate('/sessionExpired', { state: context });
};

export const logSessionExpired = (context = {}) => {
  if (!context) return;
  try {
    datadogLogs.logger.error('session_expired_navigated', context);
  } catch (error) {
    // Ignore if Datadog SDKs are not initialized
  }
};
